import React from 'react';
import { LoopLibrary } from '@/components/LoopLibrary/LoopLibrary';
import { LibraryToggle } from '@/components/LibraryToggle';
import { TimelineArea } from '@/components/Timeline/TimelineArea';
import { PizzulCoach } from '@/components/Coach/PizzulCoach';
import { LyricsPanel } from '@/components/Modals/LyricsPanel';

export const MainLayout = ({
  libraryCollapsed, onToggleLibrary,
  tracks, totalBars, sectionMarkers, playheadBar, isPlaying, loopRegion, loopEnabled,
  onLoopRegion, onToggleLoop,
  sessionBpm,
  onAddTrack, onPreviewLoop, onStopPreview, previewingLoopId, onKnockEngine,
  knockInFlight, arrangementNotice,
  onKnockControl, armedTrackId, onArmTrack, onDuplicateTrack, showTrackArms, producerMode,
  onSeekToBar, onMute, onSolo, onDelete, onRenameTrack, onMixDraft, onMixCommit, onSelectTrack,
  activeTool, selectedClipIds, onSelectClip, onMoveClip, onSliceClip, onDuplicateClip, onDeleteClip, onTrimClipEdge, onResetClip, onLoopClip,
  onEditPattern, onMakeUnique, onClipSound, bottomPanel, editRow,
  pxPerBar,
  coachStep, onCoachAction, coachCommand, kiosk,
  tempoLock, onReleaseTempoLock, onRelockTempo,
  lyricsOpen, onCloseLyrics, lyrics, onLyricsChange, onAddParsedSong,
  lyricsImportOverflow, lyricsUndoResetKey, aiDisabledCaption,
  classControls, classCoach, classSession, onSendToBank, unavailableTrackIds,
  showLibrary = true, allowLyrics = true, allowClipSound = true, classHighlight, onTimelineResize, readOnly = false,
}) => {
  return (
    <div data-testid="main-layout" className={`main-layout${readOnly ? ' is-read-only' : ''}`} aria-disabled={readOnly || undefined} inert={readOnly ? '' : undefined}>
      {showLibrary && <LoopLibrary collapsed={libraryCollapsed} onAddTrack={onAddTrack} onPreviewLoop={onPreviewLoop} onStopPreview={onStopPreview} previewingLoopId={previewingLoopId} onKnockEngine={onKnockEngine} knockInFlight={knockInFlight} arrangementNotice={arrangementNotice} coachCommand={coachCommand} tempoLock={tempoLock} onReleaseTempoLock={onReleaseTempoLock} onRelockTempo={onRelockTempo} />}
      {showLibrary && <LibraryToggle collapsed={libraryCollapsed} onToggle={onToggleLibrary} />}
      <div className="flex flex-col flex-1 overflow-hidden">
      {classCoach || <PizzulCoach step={coachStep} onAction={onCoachAction} kiosk={kiosk} />}
      {classControls}
      {editRow}
      <TimelineArea
        tracks={tracks} totalBars={totalBars} sectionMarkers={sectionMarkers} playheadBar={playheadBar} loopRegion={loopRegion} loopEnabled={loopEnabled} onLoopRegion={onLoopRegion} onToggleLoop={onToggleLoop}
        sessionBpm={sessionBpm}
        pxPerBar={pxPerBar}
        onSeekToBar={onSeekToBar} onMute={onMute} onSolo={onSolo} onDelete={onDelete} onRenameTrack={onRenameTrack} onMixDraft={onMixDraft} onMixCommit={onMixCommit}
        onKnockControl={onKnockControl} armedTrackId={armedTrackId} onArmTrack={onArmTrack} onDuplicateTrack={onDuplicateTrack} onSendToBank={onSendToBank} showTrackArms={showTrackArms} producerMode={producerMode}
        onSelectTrack={onSelectTrack}
        activeTool={activeTool} selectedClipIds={selectedClipIds}
        onSelectClip={onSelectClip} onMoveClip={onMoveClip}
        onSliceClip={onSliceClip} onDuplicateClip={onDuplicateClip} onDeleteClip={onDeleteClip}
        onTrimClipEdge={onTrimClipEdge} onResetClip={onResetClip} onLoopClip={onLoopClip} onEditPattern={onEditPattern} onMakeUnique={onMakeUnique} onClipSound={onClipSound} kiosk={kiosk}
        onQuickStart={onCoachAction}
        classSession={classSession}
        unavailableTrackIds={unavailableTrackIds}
        allowClipSound={allowClipSound}
        classHighlight={classHighlight}
        onViewportWidth={onTimelineResize}
      />
      {bottomPanel}
      </div>
      <LyricsPanel
        isOpen={allowLyrics && lyricsOpen}
        onClose={onCloseLyrics}
        lyrics={lyrics}
        onChange={onLyricsChange}
        sectionMarkers={sectionMarkers}
        onAddParsedSong={onAddParsedSong}
        kiosk={kiosk}
        aiDisabledCaption={aiDisabledCaption}
        importOverflowCount={lyricsImportOverflow}
        undoResetKey={lyricsUndoResetKey}
        playheadBar={playheadBar}
        totalBars={totalBars}
        isPlaying={isPlaying}
      />
    </div>
  );
};

export default MainLayout;
